export default __webpack_public_path__ + "static/media/icon-email-marketing-sent.2ba3a6a8.svg";